import { render, staticRenderFns } from "./CreateESGScopeConversion.vue?vue&type=template&id=207b586a"
import script from "./CreateESGScopeConversion.vue?vue&type=script&lang=js"
export * from "./CreateESGScopeConversion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports